import { SnackbarStatus } from '@weareopenr/component-library';
import { SnackbarContextValue } from '@weareopenr/component-library/build/components/Snackbar/types';
import { IMenuRequest } from 'src/api/types';
import { MenuProp } from 'src/helpers/menus/menus.types';
import { createMenu } from '../../../api/createMenu/createMenu';
import { updateMenu } from '../../../api/updateMenu/updateMenu';

export const createAndUpdateMenuOnSubmit = async (
  variant: 'update' | 'create',
  closeModal: () => void,
  id: string,
  payload: IMenuRequest,
  showSnackbar: SnackbarContextValue['showSnackbar'],
) => {
  try {
    const json = variant === 'update' ? await updateMenu(id, payload) : await createMenu(payload);
    const menu: MenuProp = json.data[0];

    showSnackbar({
      message:
        variant === 'update'
          ? `You have successfully updated menu ${menu.name}.`
          : `You have successfully created ${menu.name}.`,
      status: SnackbarStatus.SUCCESS,
    });
    closeModal();
  } catch (e) {
    showSnackbar({
      status: SnackbarStatus.ERROR,
      message: `Something went wrong whilst ${variant === 'create' ? 'creating' : 'updating'} the menu`,
    });
    throw e;
  }
};
